const TokenService = {
    setToken: (accessToken, refreshToken) => {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
    },

    getAccessToken: () => localStorage.getItem("accessToken"),
    getRefreshToken: () => localStorage.getItem("refreshToken"),

    removeToken: () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
    }
};

export default TokenService
